import { ArrowPathIcon, ClockIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { useVersionCheck } from '../hooks/useVersionCheck'

export default function VersionUpdateNotification() {
  const { hasUpdate, dismiss, reload } = useVersionCheck()

  if (!hasUpdate) return null

  return (
    <div className="version-notification" role="alert" aria-live="polite">
      <div className="version-notification-card">
        <div className="version-notification-header">
          <ArrowDownTrayIcon className="version-notification-icon" aria-hidden="true" />
          <span className="version-notification-title">Update Available</span>
        </div>
        <p className="version-notification-body">
          A new version is available. Reload to get the latest features and fixes.
        </p>
        <div className="version-notification-actions">
          <button
            onClick={dismiss}
            className="version-notification-btn version-notification-btn--secondary"
            aria-label="Remind me later"
          >
            <ClockIcon className="version-notification-btn-icon" aria-hidden="true" />
            Later
          </button>
          <button
            onClick={reload}
            className="version-notification-btn version-notification-btn--primary"
            aria-label="Reload page to update"
          >
            <ArrowPathIcon className="version-notification-btn-icon" aria-hidden="true" />
            Reload
          </button>
        </div>
      </div>
    </div>
  )
}
